<mat-icon *ngIf="this.params.value" class="mat-icon-sty color-st" fontSet="material-icons-outlined">
  done
</mat-icon>